export const MOCK_BLOCKCHAIN_DELAY = 2000;
export const MOCK_NETWORK_DELAY = 500;

export const mockBlockchainDelay = async (): Promise<void> => {
    await new Promise((resolve) => setTimeout(resolve, MOCK_BLOCKCHAIN_DELAY));
};

export const mockNetworkDelay = async (): Promise<void> => {
    await new Promise((resolve) => setTimeout(resolve, MOCK_NETWORK_DELAY));
};
